<template>
    <div class="d-inline-block position-relative px-1 variant-dropdown" v-click-outside="hideDropdown">
        <a ref="button" class="pl-2 px-1 py-1 border border-dark text-body"
           v-bind:class="{'bg-light' : (value !== ''), 'bg-primary': (value === ''), 'bg-white': opened}"
           v-html="selectedVariant"
           v-on:click.prevent.stop="toggleDropdown"></a>

        <table ref="tooltip" class="variants-list bg-white table table-bordered table-sm" :class="{'d-none': !opened}">
            <tbody class="">
                <template v-for="(variants, rIndex) in chunk(question.variants, 2)">
                    <tr>
                        <td v-for="(variant, index) in variants" class="border border-dark p-0 variant" :key="variant.id">
                            <a href="#" v-on:click.prevent="selectVariant(variant)" class="p-3 btn-link btn-block text-nowrap">
                                {{variant.text}}
                            </a>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'
    import {createPopper} from '@popperjs/core';

    export default {
        directives: {
            ClickOutside
        },

        data() {
            return {
                opened: false,
                popperInstance: null
            }
        },

        mounted() {
            if (this.$refs.button && this.$refs.tooltip) {
                this.popperInstance = createPopper(this.$refs.button, this.$refs.tooltip, {
                    placement: 'bottom-start',
                });
            }
        },

        props: {
            question: Object,
            value: String
        },

        computed: {
            selectedVariant() {
                let text = ''

                if (this.value) {
                    const variant = this.question.variants.find((vatiant) => {
                        return vatiant.id.toString() === this.value;
                    })

                    if (variant && variant.text) {
                        text += variant.text
                    }
                }

                if (this.opened) {
                    text += '<i class="ico vox-mdi-chevron-up ml-3"></i>'
                } else {
                    text += '<i class="ico vox-mdi-chevron-down ml-3"></i>'
                }

                return text
            }
        },

        methods: {
            hideDropdown() {
                this.opened = false
                this.popperInstance.update()
            },

            toggleDropdown() {
                this.opened = !this.opened;
                this.popperInstance.update()
            },

            selectVariant(variant) {
                this.$emit('input', {questionId: this.question.id, value: variant.id.toString()})
                this.hideDropdown()
            },

            chunk(arr, size) {
                return Array.from({length: Math.ceil(arr.length / size)}, (v, i) =>
                    arr.slice(i * size, i * size + size)
                );
            }
        },


    }
</script>
